import React from 'react';
import crossIcon from "../../assets/cross.svg";

const PatientTag = ({ name, id, removeApprovedPatient }) => {
    return (
      <div className="shadow-sm tag px-1 " style={{ padding: "2px" }}>
        <span className="mx-1" style={{ fontSize: "0.8rem", color: "#4F4F4F" }}>
          {name}
        </span>
        <img
          src={crossIcon}
          // className="fa fa-close approved-close-icon"
          style={{ cursor: "pointer", width: "0.5rem" }}
          onClick={(e) => removeApprovedPatient(e, id)}
        ></img>
      </div>
    );
  };
export default PatientTag  